import { darken } from 'polished';
import styled, { css } from 'styled-components';

export const MapBlock = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;

    .autosize-input {
      min-width: 1px;
      padding: 2px 4px;
      font: 14px Arial, sans-serif;
      border: 1px solid #999;
      border-radius: 2px;
      field-sizing: content;
    }

    .ol-tooltip {
      pointer-events: none;
      position: relative;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      color: white;
      padding: 4px 8px;
      opacity: 0.7;
      white-space: nowrap;
      font-size: 12px;
      cursor: default;
      user-select: none;
    }
    .ol-tooltip-measure {
      opacity: 1;
      font-weight: bold;
    }
    .ol-tooltip-static {
      background-color: #ffcc33;
      color: black;
      border: 1px solid white;
    }
    .ol-tooltip-measure:before,
    .ol-tooltip-static:before {
      border-top: 6px solid rgba(0, 0, 0, 0.5);
      border-right: 6px solid transparent;
      border-left: 6px solid transparent;
      position: absolute;
      bottom: -6px;
      margin-left: -7px;
      left: 50%;
    }
    .ol-tooltip-static:before {
      border-top-color: #ffcc33;
    }

    .ol-zoom {
      padding: ${theme.spacings[12]};

      position: fixed;
      right: 0;

      button {
        width: 3rem;
        height: 3rem;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: ${theme.font.sizes['2xl']};

        border: 1px solid ${theme.colors.gray900};
        border-radius: ${theme.radius.xs};

        background-color: ${theme.colors.white};
        color: ${theme.colors.gray900};

        transition: all 0.2s;

        & + button {
          margin-top: ${theme.spacings[4]};
        }

        &:hover {
          background-color: ${darken(0.1, theme.colors.white)};
        }
      }
    }

    .ol-rotate {
      display: none;
    }

    .ol-zoom-extent {
      display: none;
    }

    .ol-mouse-position {
      min-width: 18rem;
      padding: ${theme.spacings[12]};
      position: absolute;
      right: ${theme.spacings[12]};
      bottom: ${theme.spacings[64]};

      font-weight: ${theme.font.weights.semiBold};
      text-align: center;

      border: 1px solid ${theme.colors.gray900};
      border-radius: ${theme.radius.xs};

      background-color: ${theme.colors.white};
      color: ${theme.colors.gray900};

      @media (max-width: 500px) {
        font-size: ${theme.font.sizes.xxs};
        max-width: 13rem;
        min-width: 13rem;
      }
    }

    .ol-scale-line {
      max-width: 18rem;
      padding: ${theme.spacings[4]};
      position: absolute;
      right: ${theme.spacings[12]};
      bottom: ${theme.spacings[32]};

      font-weight: ${theme.font.weights.semiBold};
      text-align: center;

      border: 1px solid ${theme.colors.gray50};
      border-radius: ${theme.radius.xs};

      background-color: ${theme.colors.black};
      color: ${theme.colors.white};

      div {
        width: 18rem !important;

        @media (max-width: 500px) {
          width: 13rem !important;
        }
      }

      @media (max-width: 500px) {
        font-size: ${theme.font.sizes.xxs};
        max-width: 13rem;
        min-width: 13rem;
      }
    }
  `}
`;
